import React from "react";
import { Link } from "react-router-dom";
import { useSubscription } from "../../hooks/useSubscription";

/**
 * Badge pill che mostra lo stato del piano utente (Pro / Trial / Free).
 * Se cliccabile (trial o free), naviga alla pagina di checkout.
 */
export default function UserBadge() {
  const { plan, daysLeft, isTrialExpired, isPro, isAdmin, loading } = useSubscription();

  if (loading) return null;

  const baseClasses =
    "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold text-white";

  // Priorità: Admin > Pro > Trial > Free. Badge non cliccabile (nessun <Link>).
  if (isAdmin) {
    return (
      <span
        className={`${baseClasses} bg-indigo-900`}
        aria-label="Account amministratore, accesso completo"
      >
        Admin
      </span>
    );
  }

  if (isPro) {
    return (
      <span className={`${baseClasses} bg-emerald-500`}>
        Pro
      </span>
    );
  }

  if (plan === "trial" && !isTrialExpired) {
    const label = daysLeft != null ? `Trial · ${daysLeft} giorni` : "Trial";
    return (
      <Link
        to="/checkout"
        className={`${baseClasses} bg-amber-400`}
        aria-label="Piano di prova, vai al checkout per passare a Pro"
      >
        {label}
      </Link>
    );
  }

  return (
    <Link
      to="/checkout"
      className={`${baseClasses} bg-gray-400`}
      aria-label="Piano Free, vai al checkout per passare a Pro"
    >
      Free
    </Link>
  );
}
